class Token {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.url = new URL(location.href)
    this.valueParam = new URLSearchParams(this.url.search)
    this.qrcode = this.valueParam.get('qrcode')
    this.longlife = this.valueParam.get('longlife')

    this.updateUrl()
    this.checkCookie('DIOR_GM_30')
  }

  updateUrl() {
    this.url.searchParams.delete('qrcode');
    this.url.searchParams.delete('longlife');
    window.history.replaceState({'page': 'home'}, '', this.url.href)
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  checkCookie(cname) {
    let value = this.getCookie(cname);
    let expireDate

    if (this.longlife == 'true') {
      expireDate = 3650
    } else {
      expireDate = 1/12
    }

    if (value == '' && this.qrcode == 'ivDMgMx5RXw3oCKcMQJjf5') {
      this.setCookie('DIOR_GM_30', this.encode_cookie('hAV8JeYyQxVAxy8/6jWimFA9BY9a6Vm4G1YV9TDovvs='), expireDate)
    }

    if (value != '' && this.qrcode == 'ivDMgMx5RXw3oCKcMQJjf5' && this.longlife == 'true') {
      this.deleteCookie('DIOR_GM_30') 
      this.setCookie('DIOR_GM_30', this.encode_cookie('hAV8JeYyQxVAxy8/6jWimFA9BY9a6Vm4G1YV9TDovvs='), 3650)
    }

    if(value != '' && this.qrcode == 'ivDMgMx5RXw3oCKcMQJjf5' ) {
      return
    }

    const event = new CustomEvent("token:done")

    setTimeout(() => {
      window.dispatchEvent(event)
    }, 100)
  }
  deleteCookie(name) { 
    this.setCookie(name, '', -1); 
  }

  encode_cookie(cookie_value) {
    // This variable holds the encoded cookie characters
    var coded_string = ""
    
    // Run through each character in the cookie value
    for (var counter = 0; counter < cookie_value.length; counter++) {
    
      // Add the character's numeric code to the string
      coded_string += cookie_value.charCodeAt(counter)
      
      // Separate each code with a plus sign (+)
      if (counter < cookie_value.length - 1) {
        coded_string += "+"
      }
    }
    return coded_string
  }

  decode_cookie(coded_string) {
    // This variable holds the decoded cookie value
    var cookie_value = ""
    
    // Use + to split the coded string into an array
    var code_array = coded_string.split("+")
    
    // Loop through the array
    for (var counter = 0; counter < code_array.length; counter++) {

      // Convert the code into a character and 
      // add it to the cookie value string
      cookie_value += String.fromCharCode(code_array[counter])
    }
    return cookie_value
  }

  removeParams(sParam) {
    var url = window.location.href.split('?')[0]+'?';
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
  
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] != sParam) {
            url = url + sParameterName[0] + '=' + sParameterName[1] + '&'
        }
    }
    return url.substring(0,url.length-1);
  } 

}

export default Token
